import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requiredDataLoaded } from 'src/store/commonPart/selector';
import { commonSlice } from 'src/store/commonPart/slice';
import { useOnResize } from 'src/utils/hooks/useWindowSize';

export const CommonSizes: React.FC = () => {
  /** it's allowed to be used only here */
  const sizes = useOnResize(200, true);

  const dispatch = useDispatch();

  const appFinishedLoading = useSelector(requiredDataLoaded);

  /**
   * when app loads
   * listen to sizes changes and synchronize it in the store
   */
  useEffect(() => {
    /** prevent dispatching empty values when the App isn't ready */
    if (appFinishedLoading && sizes.innerWidth > 0) {
      dispatch(
        commonSlice.actions.setCommon({
          ...sizes,
        })
      );
    }
  }, [sizes, dispatch, appFinishedLoading]);

  return null;
};
